import { createSelector } from '@ngrx/store';
import { getMultipleOrderOnlineState } from '../reducers';
import { OrderForm } from '../reducers/orders-forms.reducer';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

import { selectProductTypes } from 'app/shared/upload-document/redux/selectors/product-type.selector';

export const selectOrdersFormsState = createSelector(
  getMultipleOrderOnlineState,
  (state) => state && state.ordersForms,
);
export const selectPurchaseOrderState = createSelector(getMultipleOrderOnlineState, (state) => state.purchaseOrder);

export const getMaximumNumberOfOrders = createSelector(
  selectOrdersFormsState,
  (state) => state && state.maximumNumberOfOrders,
);

export const getOrdersForms = createSelector(selectOrdersFormsState, (state) => state && state.entities);

export const getTotalNumberOfOrdersForms = createSelector(
  selectOrdersFormsState,
  (state) => state && state.ids && state.ids.length,
);

export const getFormWithId = (formId: string) =>
  createSelector(selectOrdersFormsState, (state) => {
    return state && state.entities[formId];
  });

export const getValuesFormId = (formId: string) =>
  createSelector(selectOrdersFormsState, (state) => {
    return state && state.entities[formId]?.values;
  });

export const getLatestDuplicatedOrdersFormsIds = createSelector(
  selectOrdersFormsState,
  (state) => state && state.latestDuplicatedOrdersFormsIds,
);

export const getSelectedOrderFormId = createSelector(selectOrdersFormsState, (state) => state?.selectedOrderFormId);

export const getSelectedOrderForm = createSelector(
  selectOrdersFormsState,
  (state) => state?.entities[state.selectedOrderFormId],
);

export const getOrdersFormsAsArray = createSelector(selectOrdersFormsState, (state) => {
  if (state && state.entities) {
    const entities = state.entities;
    const ids = state.ids;
    return ids.map((_id: any) => entities[_id]);
  }
  return [];
});

export const getFormsAndProducts = createSelector(getOrdersForms, selectProductTypes, (orderForms, productTypes) => {
  return orderForms;
});

export const getOrderFormsWithOrderConfirmation = createSelector(getOrdersForms, (state) => {
  const forms: OrderForm[] = [];
  for (const key in state) {
    if (Object.prototype.hasOwnProperty.call(state, key) && state[key].orderConfirmation) {
      forms.push(state[key]);
    }
  }
  return forms;
});

export const getSelectedPodAddress = (formId: string) =>
  createSelector(getFormWithId(formId), (state) => state && state.selectedPodAddress);

export const getOrderConfirmationById = (formId: string) =>
  createSelector(getOrdersForms, (state) => _safe(() => state[formId], null));

export const selectPricesState = createSelector(getMultipleOrderOnlineState, (state) => state && state.prices);

export const selectDcoOverdue = createSelector(
  getMultipleOrderOnlineState,
  (state) => state && state.prices && state.prices.dcoOverdueTimer,
);
